import { fetchFeaturedCrews, fetchUserMemberships } from '../../ducks/crews.duck';
import { fetchLinkups, fetchUserLinkups } from '../../ducks/linkups.duck';

export const loadData = () => (dispatch, getState) => {
  const state = getState();
  const currentUser = state.user?.currentUser;
  const userId = currentUser?.id?.uuid;

  const requests = [
    dispatch(fetchFeaturedCrews({ sortBy: 'recent', limit: 24 })),
    dispatch(fetchLinkups({ limit: 12 })),
  ];

  if (userId) {
    requests.push(dispatch(fetchUserMemberships(userId)));
    requests.push(dispatch(fetchUserLinkups(userId)));
  }

  return Promise.all(requests);
};
